import { render, staticRenderFns } from "./ownList.vue?vue&type=template&id=701c852d&scoped=true"
import script from "./ownList.vue?vue&type=script&lang=js"
export * from "./ownList.vue?vue&type=script&lang=js"
import style0 from "./ownList.vue?vue&type=style&index=0&id=701c852d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "701c852d",
  null
  
)

export default component.exports